var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#24adf3",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.44531,2.01172c-0.3885,0.01362 -0.77605,0.11488 -1.12305,0.29688c0.905,0.448 1.54344,1.33281 1.64844,2.38281c0.018,0.126 0.0293,0.24087 0.0293,0.29688v40c0,1.186 -0.69341,2.20245 -1.69141,2.68945c0.364,0.199 0.77041,0.31055 1.19141,0.31055c0.373,0 0.72497,-0.08642 1.04297,-0.23242l0.00195,0.00391c1.608,-0.832 9.64736,-4.99506 9.94336,-5.16406c0.933,-0.535 1.51172,-1.53442 1.51172,-2.60742v-30c0,-0.998 -0.49427,-1.92638 -1.32227,-2.48437c-0.32,-0.217 -10.0957,-5.26758 -10.0957,-5.26758l-0.00195,0.00391c-0.356,-0.1675 -0.74627,-0.24214 -1.13477,-0.22852zM33,3.98828c-0.25588,0 -0.51203,0.09747 -0.70703,0.29297c0,0 -5.7245,6.43759 -12.0625,13.55859l7.49414,6.13086l6.27539,-5.28516v-13.69727c0,-0.256 -0.09797,-0.51203 -0.29297,-0.70703c-0.1955,-0.1955 -0.45116,-0.29297 -0.70703,-0.29297zM8,10.98828c-0.156,0 -0.44614,0.00056 -1.74414,0.60156c-0.715,0.331 -3.20508,1.63867 -3.20508,1.63867c-0.33,0.179 -0.5962,0.4592 -0.7832,0.7832c0.076,-0.012 0.15147,-0.02344 0.23047,-0.02344h0.00195c0.668,0 1.07766,0.46619 1.22266,0.61719c0,0 28.20731,30.72684 28.57031,31.08984c0.195,0.195 0.44908,0.29297 0.70508,0.29297c0.256,0 0.51203,-0.09797 0.70703,-0.29297c0.195,-0.195 0.29492,-0.45103 0.29492,-0.70703v-13.33008c0,0 -24.46625,-19.99639 -24.65625,-20.15039c-0.368,-0.334 -0.84675,-0.51953 -1.34375,-0.51953zM2.19922,15.98828c-0.11,0 -0.19922,0.09017 -0.19922,0.20117v18.60547c0,0.107 0.08731,0.19531 0.19531,0.19531c0.056,0 0.10562,-0.02545 0.14063,-0.06445l5.66406,-6.28711v-6.63086l-5.6582,-5.96094c-0.036,-0.036 -0.08758,-0.05859 -0.14258,-0.05859zM12.25391,26.80273c0,0 -8.59536,9.65005 -8.69336,9.74805c-0.271,0.271 -0.64555,0.4375 -1.06055,0.4375c-0.078,0 -0.15352,-0.00948 -0.22852,-0.02148c0.202,0.351 0.49823,0.64036 0.86523,0.81836l-0.00391,0.00586c0.87,0.442 3.74114,1.90069 4.11914,2.05469c0.238,0.095 0.48905,0.14258 0.74805,0.14258c0.347,0 0.69005,-0.08962 0.99805,-0.26562c0.023,-0.013 8.5293,-7.16992 8.5293,-7.16992z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.871759cc3add36019e723a523fa6a266.svg";
export { ForwardRef as ReactComponent };